export const TEST_ID = 'obstacleCard';

export const OBSTACLE_LIGHTING_FALLBACK = 'none';

export const OBSTACLE_MARKING_FALLBACK = 'none';
